import * as moment from 'moment'
import { Occupation } from './services/personnel/occupation';

export class AppGlobals {

  public static TYPE_HEURE_PRESTE = 1;
  public static TYPE_HEURE_NON_PRESTE = 2;

  public static CLE_UNITE_VALEUR = 1;
  public static CLE_UNITE_HEURE = 2;
  public static CLE_UNITE_JOUR = 3;
  public static CLE_UNITE_MONTANT = 4;

  public static CLE_ENCODAGE_HEURE_DEBFIN = 0;
  public static CLE_ENCODAGE_HEURE_DUREE = 1;

  public static heureToMin(heure: string) : number {
    let a = heure.split(':');
    return (+a[0]) * 60 + (+a[1]);
  }

  public static minToHeure(mins) {
    let heure = Math.floor(mins / 60);
    let min = mins % 60;
    let sHeure = heure < 10 ? '0' + heure : heure;
    let sMin = min < 10 ? '0' + min : min;
    return `${sHeure}:${sMin}`;
  }

  public static toStr(str: any, def: string) : string {
    if (str != null && str.toString() != "") {
      return str.toString()
    } else {
      return def
    }
  }

  public static dateToStr(date: Date) : string {
    return date ? moment(date).format('DD/MM/YYYY') : "";
  }

  public static getClePO(occupations: Occupation[]): number {
    let clePO = -1;
    for (const occup of occupations) {
      if (clePO != null) {
        if (clePO === -1) {
          clePO = occup.ClePeriodeOccupation;
        }
        if (clePO !== occup.ClePeriodeOccupation) {
          clePO = null;
        }
      }
    }
    return clePO;
  }

  public static base64decode(str : string) : string {
    if (str == null || str.substring(0, 7) != 'Base64:')
      return str;
    else
      return atob(str.substring(7));
  }

  public static variantToStr(str: string): string{
    if(str === null){
      return '';
    }

    return str;
  }
}
